module.exports = __webpack_public_path__ + "static/media/laptop.a82377bc.png";